import $ from 'jquery'
if (!('jQuery' in window)) {
  window.jQuery = $
  window.$ = $
}
export default $

